import { render, staticRenderFns } from "./gestionaCartera.vue?vue&type=template&id=00cfdc1f"
import script from "./gestionaCartera.vue?vue&type=script&lang=js"
export * from "./gestionaCartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports